<template>
	<el-form :model="form" style="padding: 20px;" class="formBox">
		<el-form-item label="" label-width='100px'>
			<el-button type="primary" size="mini" @click="selectGoods">选择商品</el-button>						
			<el-dialog custom-class="list" :modal='false' v-if="dialogVisible" :close-on-click-modal='false' :close-on-press-escape='false'  title="选择商品" :visible.sync="dialogVisible" :modal-append-to-body='false'  width="60%">
				<el-col :span="24" class="toolbar">
					<el-form :inline="true">
						<el-form-item>
							<el-input clearable v-model="goodsSecah.goodsName" placeholder="请输入商品名称"></el-input>
							
						</el-form-item>
						<el-form-item>
							<el-button @click='goodsSecahClick'>搜索</el-button>
						</el-form-item>
					</el-form>
				</el-col>				
				<el-table :data="tableData" style="width: 100%;" border height="40vh">					
					<el-table-column prop="goodsName" label="商品名称" align="center">
					</el-table-column>
					<el-table-column prop="goodsNowPrice" label="商品现价" align="center">
					</el-table-column>
					<el-table-column prop="goodsOrgPrice" label="商品原价" align="center">
					</el-table-column>
					<el-table-column prop="goodsTypeOneName" label="一级分类名称" align="center">
					</el-table-column>
					<el-table-column prop="goodsTypeOneName" label="二级分类名称" align="center">
					</el-table-column>
					<el-table-column prop="goodsTypeThreeName" label="三级分类名称" align="center">
					</el-table-column>
					<el-table-column prop="monthlySales" label="月销量" align="center">
					</el-table-column>
					<el-table-column prop="pageViews" label="浏览量" align="center">
					</el-table-column>
					<el-table-column prop="supplierName" label="供货商名称" align="center">
					</el-table-column>
					<el-table-column fixed="right" label="操作" width="120" align="center">
						<template slot-scope="scope">
							<el-button size="mini" v-if="form.goodsId!=scope.row.goodsId"  @click="okSelect(scope.row)">选择</el-button>	
																<!-- <span v-if="form.goodsId!=scope.row.goodsId"  @click="okSelect(scope.row)">选择</span>
																<span v-else>当前选择</span> -->
							<el-button size="mini" type="primary" v-else>当前选择</el-button>										
						</template>
					</el-table-column>
				</el-table>
				<div class="page" style="margin-top: 10px;">
					<!-- <el-pagination @size-change="goodsHandleSizeChange" @current-change="goodsHandleCurrentChange"
						:current-page.sync="goodsSecah.pageNum" :page-sizes="[10, 20, 50, 100]" :page-size="10"
						layout="total, sizes, prev, pager, next, jumper" :total="goodsTotal">
					</el-pagination> -->
					<el-pagination @size-change="goodsHandleSizeChange" @current-change="goodsHandleCurrentChange"
						:current-page.sync="goodsSecah.pageNum" :page-sizes="[10, 20, 50, 100]" :page-size="10"
						layout="total, sizes, prev, pager, next, jumper" :total="goodsTotal">
					</el-pagination>
				</div>
				
			</el-dialog>
			
		</el-form-item>
		<el-form-item label="" label-width='100px'>
			<el-button type="primary" size="mini" @click="selectProduct">选择单品</el-button>
			
			<el-dialog custom-class="list" :modal='false' :close-on-click-modal='false' :close-on-press-escape='false'  title="选择单品" :visible.sync="productDialogVisible" v-if="productDialogVisible" :modal-append-to-body='false'  width="60%">
								
				<el-table :data="productData" style="width: 100%;" border height="50vh">					
					<el-table-column v-for="(item,index) in attrList" v-if="attrList.length!=0" :label="item.goodsAttrKeyName" align="center">
					 	<template slot-scope="scope">
					 		{{JSON.parse(scope.row.goodsSpecs)[item.goodsAttrKeyName]}}
					 	</template>							
					 </el-table-column>
					<el-table-column prop="price" width="150" label="单品价格" align="center">
					</el-table-column>
					<el-table-column prop="integral" width="150" label="积分" align="center">
					</el-table-column>
					<el-table-column prop="weight" width="150" label="重量" align="center">
					</el-table-column>
					<el-table-column fixed="right" label="操作" width="120" align="center">
						<template slot-scope="scope">
							<el-button size="mini" v-if="form.goodsSkuId!=scope.row.goodsSkuId"  @click="okSelecTproduct(scope.row)">选择</el-button>										
							<el-button size="mini" type="primary" v-else>当前选择</el-button>												
						</template>
					</el-table-column>
				</el-table>								
			</el-dialog>
		</el-form-item>
		
		<el-form-item label="名称" label-width='100px'>
			<el-input v-model="form.goodsName" autocomplete="off" placeholder="请输入名称"></el-input>
		</el-form-item>
		<el-form-item label="价格" label-width='100px'>
			<el-input v-model="form.price" autocomplete="off" placeholder="请输入价格"></el-input>
		</el-form-item>
		<el-form-item label="积分" label-width='100px'>
			<el-input v-model.number="form.integral" autocomplete="off" placeholder="请输入积分"></el-input>
		</el-form-item>
		<el-form-item label="拼团倍数" label-width='100px'>
			<el-input v-model="form.collageMultiple" autocomplete="off" placeholder="请输入拼团倍数"></el-input>
			<div style="color: red;">拼团倍数（拼团商品数量*拼团倍数=最大参与人数）</div>
		</el-form-item>
		<el-form-item label="返回比" label-width='100px'>
			<el-input v-model="form.gift" autocomplete="off" placeholder="请输入返回比"></el-input>
			<div style="color: red;">未拼中人赠送积分*gift%到红利钱包</div>
		</el-form-item>
		<el-form-item label="拼团商品数量" label-width='100px'>
			<el-input v-model.number="form.goodsNum" autocomplete="off" placeholder="请输入拼团商品数量"></el-input>
		</el-form-item>
		<!-- <el-form-item label="拼团状态" label-width='100px'>
			<el-select v-model="form.collageStatus" placeholder="请选择">
				<el-option  label="未上线" :value="1">
				</el-option>
				<el-option  label="已上线" :value="2">
				</el-option>
				<el-option  label="已结束" :value="3">
				</el-option>
				</el-option>
			</el-select>
		</el-form-item> -->
		
		<!-- <el-form-item label="最大参与人数" label-width='100px'>
			<el-input v-model.number="form.maxPersonNum" autocomplete="off" placeholder="请输入最大参与人数"></el-input>
		</el-form-item> -->
		<el-form-item label="拼团日期" label-width='100px'>
			<el-date-picker
			      v-model="form.collageDate"
			      type="datetime"
				  value-format='yyyy-MM-dd HH:mm:ss'
			      placeholder="选择日期时间">
			    </el-date-picker>
		</el-form-item>
    <el-form-item label="支付计算" label-width='100px'>
      <el-input v-model.number="form.jksAmount" autocomplete="off" placeholder="N"></el-input>
    </el-form-item>
		<!-- <el-form-item label="商品封面图" label-width='100px'>
			<el-upload class="avatar-uploader" :action="upImg+'/file/upload/pic'" :headers="headers"
				accept=".png,.jpg" :on-error='onError' :show-file-list="false" :on-success="handleAvatarSuccess">
				<img v-if="form.goodsHead" :src="webUrl+form.goodsHead" class="avatar">
				<i v-else class="el-icon-plus avatar-uploader-icon"></i>
			</el-upload>
			<div style="color: red;">请上传1:1的图片比例</div>
		</el-form-item> -->
		<!-- <el-form-item label="商品轮播图" label-width='100px'>
			<div style="display: flex;flex-wrap: wrap;">
				<div v-for='(item,index) in form.goodsBannerList' style="position: relative;">
					<i @click="delBanner(index)" class="el-icon-error"
						style="position: absolute;right:10px;top:0;font-size: 30px;"></i>
					<img style="margin-bottom: 10px;" :src="webUrl+item.path" class="avatar">
				</div>
				<el-upload style="margin-bottom: 10px;" class="avatar-uploader"
					:action="upImg +'/file/upload/batch/pic'" :headers="headers" :limit='9' :multiple="true"
					:on-error='onError' accept=".png,.jpg" :show-file-list="false" :on-success="bannerSuccess">
					<i class="el-icon-plus avatar-uploader-icon"></i>
				</el-upload>
			</div>
			<div style="color: red;">请上传1:1的图片比例</div>
		</el-form-item> -->
		<!-- <div data-v-eee9d61e="" class="el-form-item"><label class="el-form-item__label"
				style="width: 100px;">商品详情</label>
			<div style="margin-left: 100px;">
				<quill-editor ref="text" v-model="form.imageText" class="myQuillEditor" :options="editorOption" />
			</div>
		</div> -->
		<div style="text-align: right;padding: 20px;">
			<el-button @click="$emit('closeMoule',false)">取 消</el-button>
			<el-button type="primary" @click="sub">确 定</el-button>
		</div>
	</el-form>

</template>

<script>
	// import {
	// 	quillEditor
	// } from 'vue-quill-editor'
	// import 'quill/dist/quill.core.css'
	// import 'quill/dist/quill.snow.css'
	// import 'quill/dist/quill.bubble.css'
	// import quillConfig from './quill-config.js'
	export default {
		// components: {
		// 	quillEditor
		// },
		props: ["isAdd", 'goodsCollageId'],
		data() {
			return {
				webUrl: this.webUrl,
				webImgUrl: this.webImgUrl,
				// headers: {
				// 	'token': this.$store.state.token,
				// },
				// editorOption: quillConfig,
				form: {
					collageMultiple:"",//拼团倍数
					gift:"",//未拼中人赠送积分*gift%到红利钱包
					goodsNum:"",//拼团商品数量
					goodsSkuId:"",//商品skuId
					integral:"",//积分
					price:"",//价格
					jksAmount:"",//需要使用的Jks数量

					collageStatus: 1,//拼团状态 1未上线2已上线3已结束
					collageDate: "",//拼团日期
					// maxPersonNum:"",//最大参与人数
					goodsName:"",//商品名称
					goodsBannerList: [{
						goodsId: 0,//商品id
						path: ""//路径
					}],
					goodsHead:'',//商品封面
					imageText:"",//商品图文详情						
					goodsId:"",//商品Id
				},
				
				dialogVisible:false,
				productDialogVisible:false,
				tableData:[],
				goodsSecah: {
					goodsName: "",
					pageNum: 1,
					isOnShelf:1,
					pageSize: 10,
				},
				goodsTotal:0,
				attrList:[],
				productData:[]
				// goodsDetails:{}
			}
		},
		created() {

		},
		mounted() {
			if (!this.isAdd) {
				this.getDatails(this.goodsCollageId)
			}
		},
		methods: {
			//提交
			sub() {
				if (this.form.goodsId.length == 0) {
					this.$message('请输选择商品');
					return false
				}
				if (this.form.goodsSkuId.length == 0) {
					this.$message('请输选择单品');
					return false
				}
				if(this.form.price.length==0){
					this.$message('请输入价格');
					return false
				}
				if (!this.istwoNum(this.form.price)) {
					this.$message('请输入大于0的整数或者保留两位小数的价格');
					return false
				}
				this.form.price=parseFloat(this.form.price)
				if (this.form.integral.length==0) {
					this.$message('请输入大于0的正整数的积分');
					return false
				}
				if (!this.isNullNum(this.form.integral)) {
					this.$message('请输入大于0的正整数的积分');
					return false
				}
				this.form.integral=parseInt(this.form.integral)
				if (this.form.collageMultiple.length==0) {
					this.$message('请输入拼团倍数');
					return false
				}
				if (!this.istwoNum(this.form.collageMultiple)) {
					this.$message('请输入大于0的整数或者保留两位小数的拼团倍数');
					return false
				}
				this.form.collageMultiple=parseFloat(this.form.collageMultiple)
				if (this.form.gift.length==0) {
					this.$message('请输入返回比');
					return false
				}
				if (!this.istwoNum(this.form.gift)) {
					this.$message('请输入大于0的整数或者保留两位小数的返回比');
					return false
				}
				this.form.gift=parseFloat(this.form.gift)
				if (this.form.goodsNum.length==0) {
					this.$message('请输入商品数量');
					return false
				}
				if (!this.isNullNum(this.form.goodsNum)) {
					this.$message('请输入大于0的正整数的拼团商品数量');
					return false
				}
				this.form.goodsNum=parseInt(this.form.goodsNum)				
				// if(this.form.maxPersonNum!=''){
				// 	if (!this.isNullNum(this.form.maxPersonNum)) {
				// 		this.$message('请输入大于0的正整数的拼团最大参与人数');
				// 		return false
				// 	}
				// 	this.form.maxPersonNum=parseInt(this.form.maxPersonNum)
				// }				
				var url = this.isAdd ? "/goodsCollage/add" : "/goodsCollage/update"
				console.log(this.form)
				if (this.isAdd) {
					this.httpPost(url, this.form, true, {
						'Content-Type': 'application/json'
					}).then(res => {
						console.log(res)
						if (res.code == 200) {
							this.$message.success('新增成功');
							this.$emit('closeMoule', true)
						}
					})
				} else {
					this.httpPut(url, this.form, true, {
						'Content-Type': 'application/json'
					}).then(res => {
						console.log(res)
						if (res.code == 200) {
							this.$message.success('修改成功');
							this.$emit('closeMoule', true)
						}
					})
				}

			},
			//选择商品
			selectGoods(){
				this.dialogVisible=true
				this.getGoodsList()	
			},
			//选择单品
			selectProduct(){
				if(this.form.goodsId!=''){
					this.getAttr()
					this.productDialogVisible=true
				}else{
					this.$message.error("请选择商品")
				}				
			},
			//确定选择商品
			okSelect(row){
				console.log(row)
				this.getGoodsDatails(row.goodsId)
			},
			//确定选择单品
			okSelecTproduct(row){
				this.productDialogVisible=false
				this.form.goodsSkuId=row.goodsSkuId
				this.form.integral=row.integral
				this.form.price=row.price
				// console.log(row)
				// this.getGoodsDatails(row.goodsId)
			},
			//商品搜索
			goodsSecahClick(){
				this.getGoodsList()
			},
			//商品选择分页条数
			goodsHandleSizeChange(e) {
				this.goodsSecah.pageNum = 1
				this.goodsSecah.pageSize = e
				this.getGoodsList()
			},
			//商品页码
			goodsHandleCurrentChange(e) {
				this.goodsSecah.pageNum = e
				this.getGoodsList()
			},
			//获取商品列表
			getGoodsList() {
				this.httpPost("/goods/listByPage", this.goodsSecah, true, {
					'Content-Type': 'application/json'
				}).then(res => {
					if (res.code == 200) {
						this.tableData = res.data.content
						this.goodsTotal = res.data.total
					}
				})
			
			},
			//获取商品详情
			getGoodsDatails(id){
				this.httpPost("/goods/getOne?"+this.$qs.stringify({
						goodsId: id
					})).then(res => {
						console.log(res)
					if (res.code == 200) {						
						this.dialogVisible=false
						// this.goodsDetails = res.data
						this.form.goodsId=res.data.goodsId
						this.form.goodsName=res.data.goodsName
						this.form.imageText=res.data.imageText
						this.form.goodsHead=res.data.goodsHead
						this.form.goodsBannerList=res.data.goodsBannerList
					}
				})
			},
			
			
			//获取属性数据
			getAttr() {
				this.httpPost("/goods/getAttr?" + this.$qs.stringify({
					goodsId: this.form.goodsId
				})).then(res => {
					if (res.code == 200) {
						this.attrList = res.data
						this.getSku()
					}
				})
			},
			
			//获取单品数据
			getSku() {
				this.httpPost("/goods/getSku?" + this.$qs.stringify({
					goodsId: this.form.goodsId
				})).then(res => {
					if (res.code == 200) {
						this.productData = res.data
					}
				})
			},
			
			// //上传封面图片回调
			// handleAvatarSuccess(res, file) {
			// 	this.form.goodsHead = res.data.path
			// },
			// //上传banner图片回调
			// bannerSuccess(res) {
			// 	console.log(res)
			// 	let that = this
			// 	this.form.goodsBannerList.push({
			// 		path: res.data.path0,
			// 		goodsBannerId: '',
			// 		goodsId: that.goodsId
			// 	})

			// },
			// onError() {
			// 	this.$message.error("上传失败")
			// },
			// //删除banner
			// delBanner(index) {
			// 	this.form.goodsBannerList.splice(index, 1)
			// },

			//获取详情
			getDatails(id) {
				this.httpPost("/goodsCollage/getOne?" + this.$qs.stringify({
					goodsCollageId: id
				})).then(res => {
					console.log(res)
					if (res.code == 200) {
						
						this.form = res.data
					}
				})
			}
		},


	}
</script>



<style scoped lang='scss'>
	.page {
		/* padding: 20px 0; */
	}

	.formBox {
		height: 60vh;
		overflow-y: auto;
	}
	.avatar-uploader .el-upload {
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}
	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}
	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 178px;
		height: 178px;
		border: 1px solid #d9d9d9 !important;
		line-height: 178px !important;
		text-align: center;
	}
	.avatar {
		width: 178px;
		height: 178px;
		display: block;
		margin-right: 10px;
	}
	::v-deep .list{
		height: 65vh;
	}
	::v-deep.el-dialog__body{
		padding:0 20px !important;
	}
	/* ::v-deep .ql-editor {
		height: 300px !important;
	}
	::v-deep .el-dialog {
		margin: 4% auto auto auto !important;
		max-height: 80vh;
		min-height: 80vh;

		.el-dialog__body {
			position: absolute;
			left: 0;
			top: 54px;
			bottom: 0;
			right: 0;
			padding: 0;
			z-index: 1;
			overflow: hidden;
			overflow-y: auto;
			box-sizing: border-box;

			&::-webkit-scrollbar {
				width: 2px;
				background-color: #ccc;
			}

			&::-webkit-scrollbar-thumb {
				background-color: #0ae;
			}

			&::-webkit-scrollbar-track {
				background-color: #ccc;
			}
		}
	} */
</style>
